import React from 'react'

export default (props) => {
    return (
        <img className={props.classe} src={props.src} alt={props.alt} width={props.width} height={props.height} />
    );
}